export function IconFlag({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m15.182 7.306-10.316.765 1.984 5.56H5.138L.818.672l11.84-.303 2.524 6.938ZM4.377 6.604l8.718-.647-1.477-4.062-8.736.224 1.495 4.485Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
